import * as t from "io-ts";

/**
 * Response from the email verification send endpoint.
 *
 * - `sent`: a code was emailed to the given address.
 * - `already-verified`: the current user has already verified this address;
 *   no code is needed.
 * - `not-required`: the current user is exempt from email verification
 *   (staff / CSRs).
 */
export const EmailVerificationSendStatus = t.keyof({
    "sent": null,
    "already-verified": null,
    "not-required": null,
});
export type EmailVerificationSendStatus = t.TypeOf<
    typeof EmailVerificationSendStatus
>;

export const EmailVerificationSendResponse = t.readonly(
    t.type({
        status: EmailVerificationSendStatus,
    }),
);
export type EmailVerificationSendResponse = t.TypeOf<
    typeof EmailVerificationSendResponse
>;

export const EmailVerificationVerifyResponse = t.readonly(
    t.type({
        status: t.literal("verified"),
    }),
);
export type EmailVerificationVerifyResponse = t.TypeOf<
    typeof EmailVerificationVerifyResponse
>;
